import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { fetchClaimsData } from 'state/actions'
import moment from 'moment'
import { EasinsureClaimsList } from './EasinsureClaimsList'
import ClientClaimDetails from 'elements/ClientClaimDetails'
import { memoize } from 'lib/memoize'

@connect(state => ({
	isPhone: state.responsive.isPhone,
	isTablet: state.responsive.isTablet,
	claims: state.client.claims,
	opened: state.app.opened,
}))
export class EasinsureClaims extends Component {
	constructor(props) {
		super(props)
		this.memoizedSortClaims.bind(this)
	}

	componentDidMount() {this.update()}
	componentDidUpdate() {this.update()}
	update() {
		const { dispatch } = this.props
		dispatch(fetchClaimsData())
	}

	memoizedSortClaims = memoize((claims) => {
		return claims.sort((a, b) => {
			if (moment(a.claimMain.creationDate).isBefore(b.claimMain.creationDate)) {
				return 1
			}
			if (moment(a.claimMain.creationDate).isAfter(b.claimMain.creationDate)) {
				return -1
			}
			return 0
		})
	})

	render() {
		const {opened, claims, className, onBackClicked, onLinkClicked, isPhone, isTablet } = this.props
		const claim = opened && claims.find(c => c.claimMain.claimNumber === opened)

		return (
			claim ? (
				<ClientClaimDetails
					className={className}
					claim={claim}
					onBackClicked={onBackClicked}
				/>
			) : (
				<EasinsureClaimsList
					claimsList={this.memoizedSortClaims(claims)}
					breakpoint={{isPhone, isTablet}}
					onSelectClaimClicked={onLinkClicked}
				/>
			)
		)
	}
}
EasinsureClaims.propTypes = {
	opened: PropTypes.string,
	claims: PropTypes.array,
	className: PropTypes.string,
	onBackClicked: PropTypes.func,
	onLinkClicked: PropTypes.func,
	isPhone: PropTypes.bool,
	isTablet: PropTypes.bool,
	dispatch: PropTypes.func,
}




// WEBPACK FOOTER //
// ./components/easinsure/claims/EasinsureClaims.jsx